import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tab-title',
  templateUrl: './tab-title.component.html',
})
export class TabTitleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

  }

}
